import '../../assets/index11.css';var ee = Object.defineProperty, se = Object.defineProperties;
var oe = Object.getOwnPropertyDescriptors;
var x = Object.getOwnPropertySymbols;
var q = Object.prototype.hasOwnProperty, H = Object.prototype.propertyIsEnumerable;
var W = (l, o, e) => o in l ? ee(l, o, { enumerable: !0, configurable: !0, writable: !0, value: e }) : l[o] = e, m = (l, o) => {
  for (var e in o || (o = {}))
    q.call(o, e) && W(l, e, o[e]);
  if (x)
    for (var e of x(o))
      H.call(o, e) && W(l, e, o[e]);
  return l;
}, I = (l, o) => se(l, oe(o));
var z = (l, o) => {
  var e = {};
  for (var i in l)
    q.call(l, i) && o.indexOf(i) < 0 && (e[i] = l[i]);
  if (l != null && x)
    for (var i of x(l))
      o.indexOf(i) < 0 && H.call(l, i) && (e[i] = l[i]);
  return e;
};
import { jsx as a, jsxs as R } from "react/jsx-runtime";
import { useRef as le, useMemo as J } from "react";
import { ErrorMessage as te } from "../ErrorMessage/index.js";
import { ComboboxChevron as ne } from "../../icons/ComboboxChevron.js";
import { g as ie, a as ae, u as re, C as D } from "../../Combobox-Ce8ISb27.js";
import { u as ce } from "../../use-uncontrolled-J2aphITS.js";
import { g as F, b as de } from "../../get-size-rXzn3RsE.js";
import { f as $, e as T, g as A, h as Q, B as L } from "../../factory--gUH4vxz.js";
import { C as X } from "../../CloseButton-C5bnBuOd.js";
import { c as Z } from "../../create-optional-context-CQ2ahjKQ.js";
import { G as pe } from "../../Group-BN1NB_iw.js";
import { C as ue } from "../../Checkbox-BSQC8eHj.js";
import { I as me } from "../../InputBase-DnR5w7C2.js";
import { u as fe, I as he } from "../../Input-Ccccf9Ny.js";
import { u as be } from "../../OptionalPortal-Ctng3n6E.js";
import { F as ge } from "../../Flex-C4YSourf.js";
const [_e, V] = Z(), [ve, ye] = Z();
var j = { root: "m_7cda1cd6", "root--default": "m_44da308b", "root--contrast": "m_e3a01f8", label: "m_1e0e6180", remove: "m_ae386778", group: "m_1dcfd90b" };
const Pe = {}, Ie = Q((l, { gap: o }, { size: e }) => ({
  group: {
    "--pg-gap": o !== void 0 ? F(o) : F(e, "pg-gap")
  }
})), Y = $((l, o) => {
  const e = T("PillGroup", Pe, l), s = e, { classNames: i, className: p, style: u, styles: g, unstyled: f, vars: y, size: _, disabled: v } = s, h = z(s, ["classNames", "className", "style", "styles", "unstyled", "vars", "size", "disabled"]), c = V(), t = (c == null ? void 0 : c.size) || _ || void 0, r = A({
    name: "PillGroup",
    classes: j,
    props: e,
    className: p,
    style: u,
    classNames: i,
    styles: g,
    unstyled: f,
    vars: y,
    varsResolver: Ie,
    stylesCtx: { size: t },
    rootSelector: "group"
  });
  return /* @__PURE__ */ a(ve, { value: { size: t, disabled: v }, children: /* @__PURE__ */ a(L, m(m({ ref: o, size: t }, r("group")), h)) });
});
Y.classes = j;
Y.displayName = "@mantine/core/PillGroup";
const Se = {
  variant: "default"
}, Ce = Q((l, { radius: o }, { size: e }) => ({
  root: {
    "--pill-fz": F(e, "pill-fz"),
    "--pill-height": F(e, "pill-height"),
    "--pill-radius": o === void 0 ? void 0 : de(o)
  }
})), k = $((l, o) => {
  const e = T("Pill", Se, l), U = e, {
    classNames: i,
    className: p,
    style: u,
    styles: g,
    unstyled: f,
    vars: y,
    variant: _,
    children: v,
    withRemoveButton: h,
    onRemove: c,
    removeButtonProps: t,
    radius: r,
    size: s,
    disabled: d,
    mod: N
  } = U, S = z(U, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "variant",
    "children",
    "withRemoveButton",
    "onRemove",
    "removeButtonProps",
    "radius",
    "size",
    "disabled",
    "mod"
  ]), b = ye(), C = V(), n = s || (b == null ? void 0 : b.size) || void 0, P = (C == null ? void 0 : C.variant) === "filled" ? "contrast" : _ || "default", O = A({
    name: "Pill",
    classes: j,
    props: e,
    className: p,
    style: u,
    classNames: i,
    styles: g,
    unstyled: f,
    vars: y,
    varsResolver: Ce,
    stylesCtx: { size: n }
  });
  return /* @__PURE__ */ R(
    L,
    I(m(I(m({
      component: "span",
      ref: o,
      variant: P,
      size: n
    }, O("root", { variant: P })), {
      mod: [
        { "with-remove": h && !d, disabled: d || (b == null ? void 0 : b.disabled) },
        N
      ]
    }), S), {
      children: [
        /* @__PURE__ */ a("span", I(m({}, O("label")), { children: v })),
        h && /* @__PURE__ */ a(
          X,
          I(m(m({
            variant: "transparent",
            radius: r,
            tabIndex: -1,
            "aria-hidden": !0,
            unstyled: f
          }, t), O("remove", {
            className: t == null ? void 0 : t.className,
            style: t == null ? void 0 : t.style
          })), {
            onMouseDown: (w) => {
              var M;
              w.preventDefault(), w.stopPropagation(), (M = t == null ? void 0 : t.onMouseDown) == null || M.call(t, w);
            },
            onClick: (w) => {
              var M;
              w.stopPropagation(), c == null || c(), (M = t == null ? void 0 : t.onClick) == null || M.call(t, w);
            }
          })
        )
      ]
    })
  );
});
k.classes = j;
k.displayName = "@mantine/core/Pill";
k.Group = Y;
var B = { field: "m_45c4369d" };
const we = {
  type: "visible"
}, K = $((l, o) => {
  const e = T("PillsInputField", we, l), b = e, {
    classNames: i,
    className: p,
    style: u,
    styles: g,
    unstyled: f,
    vars: y,
    type: _,
    disabled: v,
    id: h,
    pointer: c,
    mod: t
  } = b, r = z(b, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "type",
    "disabled",
    "id",
    "pointer",
    "mod"
  ]), s = V(), d = fe(), N = A({
    name: "PillsInputField",
    classes: B,
    props: e,
    className: p,
    style: u,
    classNames: i,
    styles: g,
    unstyled: f,
    rootSelector: "field"
  }), S = v || (s == null ? void 0 : s.disabled);
  return /* @__PURE__ */ a(
    L,
    I(m(m({
      component: "input",
      ref: be(o, s == null ? void 0 : s.fieldRef),
      "data-type": _,
      disabled: S,
      mod: [{ disabled: S, pointer: c }, t]
    }, N("field")), r), {
      id: (d == null ? void 0 : d.inputId) || h,
      "aria-invalid": s == null ? void 0 : s.hasError,
      "aria-describedby": d == null ? void 0 : d.describedBy,
      type: "text",
      onMouseDown: (C) => !c && C.stopPropagation()
    })
  );
});
K.classes = B;
K.displayName = "@mantine/core/PillsInputField";
const ze = {}, E = $((l, o) => {
  const t = T("PillsInput", ze, l), {
    children: i,
    onMouseDown: p,
    onClick: u,
    size: g,
    disabled: f,
    __staticSelector: y,
    error: _,
    variant: v
  } = t, h = z(t, [
    "children",
    "onMouseDown",
    "onClick",
    "size",
    "disabled",
    "__staticSelector",
    "error",
    "variant"
  ]), c = le(null);
  return /* @__PURE__ */ a(_e, { value: { fieldRef: c, size: g, disabled: f, hasError: !!_, variant: v }, children: /* @__PURE__ */ a(
    me,
    I(m({
      size: g,
      error: _,
      variant: v,
      component: "div",
      ref: o,
      onMouseDown: (r) => {
        var s;
        r.preventDefault(), p == null || p(r), (s = c.current) == null || s.focus();
      },
      onClick: (r) => {
        var s;
        r.preventDefault(), u == null || u(r), (s = c.current) == null || s.focus();
      }
    }, h), {
      multiline: !0,
      disabled: f,
      __staticSelector: y || "PillsInput",
      withAria: !1,
      children: i
    })
  ) });
});
E.displayName = "@mantine/core/PillsInput";
E.Field = K;
const De = "MultiSelect-module__pillsInput___Ysa7c", Ne = "MultiSelect-module__pill___E-PVY", Oe = "MultiSelect-module__options___1-W33", Me = "MultiSelect-module__option___IT-Wc", G = {
  pillsInput: De,
  pill: Ne,
  options: Oe,
  option: Me
}, He = (v) => {
  var h = v, {
    defaultValue: l,
    description: o,
    disabled: e,
    error: i,
    data: p,
    label: u,
    placeholder: g,
    onChange: f,
    value: y
  } = h, _ = z(h, [
    "defaultValue",
    "description",
    "disabled",
    "error",
    "data",
    "label",
    "placeholder",
    "onChange",
    "value"
  ]);
  const c = J(() => ie(p), [p]), t = J(() => ae(c), [c]), r = re({
    onDropdownClose: () => r.resetSelectedOption(),
    onDropdownOpen: (n) => {
      n === "keyboard" ? r.selectActiveOption() : r.updateSelectedOptionIndex("active");
    }
  }), [s, d] = ce({
    value: y,
    defaultValue: l || [],
    onChange: f
  }), N = (n) => {
    const P = t[n];
    d(
      s.includes(n) ? s.filter((O) => O !== n) : [...s, n],
      P
    );
  }, S = (n) => d(s.filter((P) => P !== n)), b = s.map((n) => /* @__PURE__ */ a(k, { withRemoveButton: !0, onRemove: () => S(n), className: G.pill, children: t[n].label }, n)), C = c.map((n, P) => /* @__PURE__ */ a(
    D.Option,
    {
      active: s.includes(n.value),
      value: n.value,
      onMouseOver: () => r.selectOption(P),
      className: G.option,
      disabled: n.disabled,
      children: /* @__PURE__ */ R(pe, { gap: "sm", children: [
        /* @__PURE__ */ a(ue.Indicator, { checked: s.includes(n.value), "aria-hidden": !0, tabIndex: -1, style: { pointerEvents: "none" } }),
        /* @__PURE__ */ a("span", { children: n.label })
      ] })
    },
    n.value
  ));
  return /* @__PURE__ */ R(D, { store: r, onOptionSubmit: N, withinPortal: !1, disabled: e, children: [
    /* @__PURE__ */ a(D.DropdownTarget, { children: /* @__PURE__ */ R(
      E,
      I(m({
        disabled: e,
        onClick: () => r.toggleDropdown(),
        pointer: !0,
        "data-expanded": r.dropdownOpened || void 0,
        rightSection: /* @__PURE__ */ a(ne, { size: "xs", error: i }),
        rightSectionPointerEvents: "none",
        classNames: { input: G.pillsInput },
        label: u,
        description: o,
        descriptionProps: { c: "gray.8" },
        error: i && /* @__PURE__ */ a(te, { error: i }),
        inputWrapperOrder: ["label", "input", i ? "error" : "description"]
      }, _), {
        children: [
          /* @__PURE__ */ R(k.Group, { role: "group", "aria-label": "Selected options", children: [
            s.length > 0 ? b : /* @__PURE__ */ a(he.Placeholder, { children: g }),
            /* @__PURE__ */ a(D.EventsTarget, { children: /* @__PURE__ */ a(
              E.Field,
              {
                type: "hidden",
                onBlur: () => r.closeDropdown(),
                onKeyDown: (n) => {
                  n.key === "Backspace" && (n.preventDefault(), S(s[s.length - 1]));
                }
              }
            ) })
          ] }),
          s.length > 0 && /* @__PURE__ */ a(ge, { align: "center", children: /* @__PURE__ */ a(
            X,
            {
              size: "sm",
              "aria-label": "Clear selection",
              onClick: (n) => {
                n.stopPropagation(), d([]);
              }
            }
          ) })
        ]
      })
    ) }),
    /* @__PURE__ */ a(D.Dropdown, { children: /* @__PURE__ */ a(D.Options, { "aria-label": u, className: G.options, children: C }) })
  ] });
};
export {
  He as MultiSelect
};
